import { makeActionCreator } from '../../../../../utilities'
import { MotorSensoryAssessmentConstants } from './motoSensoryAssessment.constants'

export const setMotorLa = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTORLA, 'motorLa')
export const setMotorRa = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTORRA, 'motorRa')
export const setMotorLl = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTORLL, 'motorLl')
export const setMotorRl = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTORRL, 'motorRl')
export const setSensoryLa = makeActionCreator(MotorSensoryAssessmentConstants.SET_SENSORYLA, 'sensoryLa')
export const setSensoryRa = makeActionCreator(MotorSensoryAssessmentConstants.SET_SENSORYRA, 'sensoryRa')
export const setSensoryLl = makeActionCreator(MotorSensoryAssessmentConstants.SET_SENSORYLL, 'sensoryLl')
export const setSensoryRl = makeActionCreator(MotorSensoryAssessmentConstants.SET_SENSORYRL, 'sensoryRl')
export const setMotorComments = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTORCOMMENTS, 'motorComments')
export const setHeadSensory = makeActionCreator(MotorSensoryAssessmentConstants.SET_HEADSENSORY, 'headSensory')

export const saveMotorSensory = makeActionCreator(MotorSensoryAssessmentConstants.SAVE_MOTOR_SENSORY)
export const setMotorSensoryResponse = makeActionCreator(MotorSensoryAssessmentConstants.SET_RESPONSE, 'response')
export const setMotorSensory = makeActionCreator(MotorSensoryAssessmentConstants.SET_MOTOR_SENSORY, 'motorSensory')
export const resetMotorSensoryState = makeActionCreator(MotorSensoryAssessmentConstants.RESET_MOTOR_SENSORY_STATE)

export const setMotorSensoryState = makeActionCreator(
  MotorSensoryAssessmentConstants.SET_MOTOR_SENSORY_STATE,
  'motorSensoryState'
)
